<template>
  <b-card
    :key="source.id"
    no-body
    class="activity shadow mb-3 mx-2"
  >
    <b-avatar
      v-has-permission="'ED081'"
      rounded
      class="activity-handler"
      variant="light-secondary"
      size="24"
    >
      <feather-icon icon="CrosshairIcon"/>
    </b-avatar>
    <b-card-body class="p-2">
      <b-card-title
        class="activity-description font-weight-normal mb-0 pr-8"
        @click="onSelect(source)"
      >
        {{ source.name }}
      </b-card-title>
      <hr class="my-2" />
      <!-- TODO: delete the -- check when the backend remove the value -->
      <b-badge
        v-if="source.companyStatusName && source.companyStatusName !== '--'"
        variant="light-primary"
        class="text-wrap mb-1"
      >
        <feather-icon icon="TrelloIcon" />
        {{ source.companyStatusName }}
      </b-badge>
      <!-- TODO: delete the -- check when the backend remove the value -->
      <b-badge
        v-if="!source.companyStatusName || source.companyStatusName === '--'"
        variant="light-danger"
        class="text-wrap mb-1"
      >
        <feather-icon icon="TrelloIcon" />
        <feather-icon class="ml-2" icon="AlertCircleIcon" />
      </b-badge>
      <div>
        <b-badge variant="light-primary">
          {{ source.referenceElementType }}
        </b-badge>
        <b-badge
          v-if="source.referenceId && source.referenceElementNumber"
          variant="light-success"
          class="ml-1 text-wrap mb-2"
          v-b-tooltip="source.referenceId"
        >
          #{{ source.referenceElementNumber }}
          <feather-icon icon="FileTextIcon" />
        </b-badge>
      </div>
      <div class="text-right">
        <ActivityAliveBadge
          :created-at="source.createdAt"
          :expired-at="source.expiredAt"
        />
        <b-spinner
          small
          class="ml-1"
          variant="primary"
          v-if="source.meta.isUpdating"
        />
      </div>
    </b-card-body>
  </b-card>
</template>
<script>

import ActivityAliveBadge from '@/febos/global/kanban/components/ActivityAliveBadge';

export default {
  components: { ActivityAliveBadge },
  props: {
    index: { type: Number, required: true },
    source: {
      id: { type: String, required: true },
      name: { type: String, required: true },
      description: { type: String, required: true },
      expiredAt: { type: Date, required: true },
      referenceType: { type: String, required: true },
      referenceId: String,
      companyStatusName: String,
      meta: { type: Object, default: () => {} }
    },
    onSelect: Function
  }
};

</script>

<style lang="scss" scoped>

@import '~@core/scss/base/bootstrap-extended/include';

.activity {
  position: relative;
  overflow: hidden;
}

.activity-description {
  font-size: $h5-font-size;
  line-height: $display-line-height;
  height: ($h5-font-size * $display-line-height) * 3;
  overflow: hidden;
}

.activity-reference-name {
  font-size: $font-size-base;
  line-height: $line-height-base;
  height: ($font-size-base * $line-height-base) * 2;
  overflow: hidden;
  white-space: normal;
  display: inline-block;
  font-weight: $font-weight-normal;
}

.activity-handler {
  position: absolute !important;
  right: 8px;
  top: 8px;
  z-index: 1;
}

.activity-ghost > .activity {
  opacity: .5;
}

</style>
